import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=1153b6dc&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=1153b6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1153b6dc",
  null
  
)

export default component.exports